import { ChangeDetectionStrategy,Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { AdminCurrency } from './admin-currency.pipe';

@Component({
    selector: 'admin-currency',
    templateUrl: './currency.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatTooltip, AdminCurrency],
})
export class CurrencyComponent {
    @Input()
    value: number;
    @Input()
    currency: string;

    constructor() {
    }
}
